/* VALKA · «Agrega también» en el carrito.
   Agrega con /cart/add.js y vuelve a pintar el carrito con el mecanismo de Dawn
   (Section Rendering API: cart-drawer.renderContents() o cart-items.getSectionsToRender()). */
(() => {
  if (customElements.get('valka-x-upsell')) return;

  const cartAddUrl = () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${root}cart/add.js`;
  };

  class ValkaUpsell extends HTMLElement {
    connectedCallback() {
      // Evita que <cart-items> trate el cambio de variante como un cambio de cantidad.
      this.addEventListener('change', (event) => event.stopPropagation());
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-vx-upsell-add]');
        if (button && this.contains(button)) this.add(button);
      });
    }

    async add(button) {
      if (button.getAttribute('aria-disabled') === 'true') return;
      const item = button.closest('[data-vx-upsell-item]');
      const variantInput = item && item.querySelector('[data-vx-upsell-variant]');
      const variantId = variantInput && variantInput.value;
      const errorEl = item && item.querySelector('.vx-upsell__error');
      if (!variantId) return;

      if (errorEl) errorEl.hidden = true;
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('is-loading');
      item.setAttribute('aria-busy', 'true');

      const context = this.dataset.context;
      const drawer = context === 'drawer' ? document.querySelector('cart-drawer') : null;
      const page = context === 'page' ? document.querySelector('cart-items') : null;

      let pageSections = null;
      let sectionIds = [];
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        sectionIds = drawer.getSectionsToRender().map((section) => section.id);
      } else if (page && typeof page.getSectionsToRender === 'function') {
        try {
          pageSections = page.getSectionsToRender();
          sectionIds = pageSections.map((section) => section.section);
        } catch (e) {
          pageSections = null;
        }
      }

      const body = new FormData();
      body.append('id', variantId);
      body.append('quantity', '1');
      if (sectionIds.length) {
        body.append('sections', sectionIds.join(','));
        body.append('sections_url', window.location.pathname);
      }

      try {
        const response = await fetch(cartAddUrl(), {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body,
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          this.fail(button, item, errorEl, data.description || data.message || 'No se pudo agregar el producto.');
          return;
        }

        if (drawer && data.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
          window.setTimeout(() => this.afterRender(drawer, '#CartDrawer-LiveRegionText'), 50);
        } else if (page && pageSections && data.sections) {
          pageSections.forEach((section) => {
            const host = document.getElementById(section.id);
            if (!host || !data.sections[section.section]) return;
            const target = host.querySelector(section.selector) || host;
            target.innerHTML = page.getSectionInnerHTML(data.sections[section.section], section.selector);
          });
          page.classList.remove('is-empty');
          document.getElementById('main-cart-footer')?.classList.remove('is-empty');
          this.afterRender(document, '#cart-live-region-text');
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        // publish y PUB_SUB_EVENTS vienen de pubsub.js / constants.js de Dawn (ámbito global).
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-items',
            productVariantId: variantId,
            cartData: data,
          });
        }
      } catch (error) {
        this.fail(button, item, errorEl, 'No se pudo agregar el producto. Revisa tu conexión e inténtalo de nuevo.');
      }
    }

    afterRender(scope, liveSelector) {
      const live = document.querySelector(liveSelector);
      if (live) live.textContent = 'Producto agregado al carrito.';
      const firstItem = scope.querySelector('.cart-item__name');
      if (firstItem) firstItem.focus({ preventScroll: false });
    }

    fail(button, item, errorEl, message) {
      button.removeAttribute('aria-disabled');
      button.classList.remove('is-loading');
      item.removeAttribute('aria-busy');
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      }
    }
  }

  customElements.define('valka-x-upsell', ValkaUpsell);
})();
